export const HTTP_CALL_BEGIN = "HTTP_CALL_BEGIN";
export const HTTP_CALL_END = "HTTP_CALL_END";
export const LOGIN_MODAL = "LOGIN_MODAL";
export const REGISTER_MODAL = "REGISTER_MODAL";
export const SUCCESS_MODAL = "SUCCESS_MODAL";
export const DARK_MODE = "DARK_MODE";
export const SIDEBAR_COLLAPSED = "SIDEBAR_COLLAPSED";

// Auth
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";

